module.exports = __webpack_public_path__ + "images/collapse.d0464f78e5410470cd18128706987b12.png";